// Airtable response helpers.
// Airtable formula fields that evaluate to NaN/empty return {specialValue: "NaN"}.

export const num = (v, fallback = null) => {
  if (typeof v === "number" && isFinite(v)) return v;
  return fallback;
};

export const money = (v, fallback = 0) => {
  if (typeof v === "number" && isFinite(v)) return v;
  return fallback;
};

export const str = (v, fallback = "—") => {
  if (v === undefined || v === null || v === "") return fallback;
  if (typeof v === "object" && v.specialValue) return fallback;
  return String(v);
};

export const arr = (v) => (Array.isArray(v) ? v : []);

export const fmtDate = (s) => {
  if (!s || typeof s !== "string") return "—";
  const d = new Date(s);
  if (isNaN(d.getTime())) return s;
  return d.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
};

export const fmtDateTime = (s) => {
  if (!s) return "—";
  const d = new Date(s);
  if (isNaN(d.getTime())) return String(s);
  return (
    d.toLocaleDateString("en-US", { month: "short", day: "numeric" }) +
    " · " +
    d.toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit" })
  );
};

export const timeAgo = (s) => {
  if (!s) return "";
  const t = new Date(s).getTime();
  if (isNaN(t)) return "";
  const diff = Date.now() - t;
  if (diff < 0) return "just now";
  const m = Math.floor(diff / 60000);
  if (m < 1) return "just now";
  if (m < 60) return `${m} min ago`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h} hr ago`;
  const d = Math.floor(h / 24);
  if (d < 30) return `${d}d ago`;
  const mo = Math.floor(d / 30);
  return `${mo}mo ago`;
};

// Resolve a linked-record array (["recXXX", ...]) to the first linked record's name field.
export const linkedName = (links, recById, nameField = "Full Name") => {
  if (!Array.isArray(links) || !links.length) return "—";
  const rec = recById.get(links[0]);
  if (!rec) return "—";
  return rec.fields?.[nameField] || "—";
};

export const indexById = (records) => {
  const m = new Map();
  (records || []).forEach((r) => m.set(r.id, r));
  return m;
};
